module.exports = __webpack_public_path__ + "img/asset-active.28412669.svg";